import { FC, useState, createContext, useRef } from 'react';
import { BusinessAreaDto } from 'src/models/businessArea.model';

type ActionContext = {
  actionToggle: any;
  toggleAction: () => void;
  skillOther: any;
  setSkillOtherContext: (dataValue) => void;
  skillBusinessAreaOther: any;
  setSkillBusinessAreaOtherContext: (dataValue) => void;
  errorOtherText: any;
  setErrorOtherTextContext: (dataValue) => void;
  errorSkillBusinessAreaOtherText: any;
  setErrorSkillBusinessAreaOtherText: (dataValue) => void;
  errorOtherPerTypeText: any;
  setErrorOtherPerTypeTextContext: (dataValue) => void;
  isUserHimSelf: any;
  isTeamManager: any;
  isManager: any;
  setIsUserHimSelfContext: (dataValue) => void;
  setIsTeamManagerContext: (dataValue) => void;
  setIsManagerContext: (dataValue) => void;
  hasManagerPermission: any;
  setHasManagerPermissionContext: (dataValue) => void;

  hasManagerPermissionResendBoond: any;
  setHasManagerPermissionResendBoondContext: (dataValue) => void;
  saveDcAutoRef: any;

  nbXpPro: number;
  setNbXpProContext: (dataValue) => void;

  currentIdUserDc: number;
  setCurrentIdUserDc: (dataValue) => void;
  currentIdLangUserDc: number;
  setCurrentIdLangUserDc: (dataValue) => void;
  businessAreaOK: boolean;
  setBusinessAreaOK: (dataValue) => void;
  categDataContext: BusinessAreaDto[];
  setCategDataContext: (dataValue) => void;
  mainDataContext: BusinessAreaDto[];
  setMainDataContext: (dataValue) => void;
};

export const ActionContext = createContext<ActionContext>(
  {} as ActionContext
);

export const ActionProvider: FC = ({ children }) => {
  const [actionToggle, setActionToggle] = useState(false);
  const [isUserHimSelf, setIsUserHimSelf] = useState(false);
  const [isTeamManager, setIsTeamManager] = useState(false);
  const [hasManagerPermission, setHasManagerPermission] = useState(false);
  const [hasManagerPermissionResendBoond, setHasManagerPermissionResendBoond] = useState(false);
  const [isManager, setIsManager] = useState(false);
  const [nbXpPro, setNbXpPro] = useState(0);
  const [categDataContext, setCategDataContext] = useState([]);
  const [mainDataContext, setMainDataContext] = useState([]);

  const [currentIdUserDc, setCurrentIdUserDc] = useState(0);
  const [currentIdLangUserDc, setCurrentIdLangUserDc] = useState(0);

  const [businessAreaOK, setBusinessAreaOK] = useState(true);

  const setIsUserHimSelfContext = (dataValue) => {
    setIsUserHimSelf(dataValue)
  }

  const setIsTeamManagerContext = (dataValue) => {
    setIsTeamManager(dataValue)
  }

  const setHasManagerPermissionContext = (dataValue) => {
    setHasManagerPermission(dataValue);
  }

  const setHasManagerPermissionResendBoondContext = (dataValue) => {
    setHasManagerPermissionResendBoond(dataValue);
  }

  const setIsManagerContext = (dataValue) => {
    setIsManager(dataValue)
  }

  const setNbXpProContext = (dataValue) => {
    setNbXpPro(dataValue)
  }

  const toggleAction = () => {
    setActionToggle(!actionToggle);
  };

  const [skillOther, setSkillOther] = useState("");
  const [skillBusinessAreaOther, setSkillBusinessAreaOther] = useState("");
  const [errorOtherText, setErrorOtherText] = useState("");
  const [errorSkillBusinessAreaOtherText, setErrorSkillBusinessAreaOtherText] = useState("");
  const [errorOtherPerTypeText, setErrorOtherPerTypeText] = useState("");

  const setSkillOtherContext = (dataValue) => {
    setSkillOther(dataValue)
  }
  const setSkillBusinessAreaOtherContext = (dataValue) => {
    setSkillBusinessAreaOther(dataValue)
  }

  const setErrorOtherTextContext = (dataValue) => {
    setErrorOtherText(dataValue)
  }

  const setErrorOtherPerTypeTextContext = (dataValue) => {
    setErrorOtherPerTypeText(dataValue)
  }

  const saveDcAutoRef = useRef(() => { });

  return (
    <ActionContext.Provider value={{
      actionToggle,
      toggleAction,
      skillOther,
      setSkillOtherContext,
      skillBusinessAreaOther,
      setSkillBusinessAreaOtherContext,
      errorOtherText,
      setErrorOtherTextContext,
      errorSkillBusinessAreaOtherText,
      setErrorSkillBusinessAreaOtherText,
      errorOtherPerTypeText,
      setErrorOtherPerTypeTextContext,
      isUserHimSelf,
      isTeamManager,
      isManager,
      setIsUserHimSelfContext,
      setIsTeamManagerContext,
      setIsManagerContext,
      hasManagerPermission,
      setHasManagerPermissionContext,
      hasManagerPermissionResendBoond,
      setHasManagerPermissionResendBoondContext,
      saveDcAutoRef,
      nbXpPro,
      setNbXpProContext,
      currentIdUserDc,
      setCurrentIdUserDc,
      currentIdLangUserDc,
      setCurrentIdLangUserDc,
      businessAreaOK,
      setBusinessAreaOK,
      categDataContext,
      setCategDataContext,
      mainDataContext,
      setMainDataContext
    }}
    >
      {children}
    </ActionContext.Provider>
  );
};
